import { render, staticRenderFns } from "./ValueAddedMomentsAggregatedActivity.vue?vue&type=template&id=acce13da&"
import script from "./ValueAddedMomentsAggregatedActivity.vue?vue&type=script&lang=js&"
export * from "./ValueAddedMomentsAggregatedActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports